/**
 * Checks whether the browser supports notifications and promises.
 *
 * @returns {boolean}
 */

export default function checkNotificationPromise() {
	try {
		window.Notification.requestPermission().then();
	} catch ( e ) {
		return false;
	}

	return true;
};
